// extracted by mini-css-extract-plugin
export default {"reportsContainer":"Reports_reportsContainer__oFGOK","reportsBodyFilter":"Reports_reportsBodyFilter__slhEE","reportsBodyContent":"Reports_reportsBodyContent__PV+X3"};